import React from 'react';

function PartialScores(props) {
    return (
        <div className="container-risultati-parziali-mobile">
            {props.scores.slice(1).map(score =>
                <div key={score.p} className="container-risultati-parziali-mobile_risultato-singolo">
                    <span className="container-risultati-parziali-mobile_risultato-singolo_descrizione text-small">{score.p}</span>
                    <span className="set-info text-small push-right">{`(${score.s1}-${score.s2})`}</span> 
                </div>
            )}
        </div>
    );
}

export default PartialScores;